// The billing tables show one page of rows at a time: thousands of rows (each unmatched one with two dropdowns)
// froze the browser.
const pageSize = 100;

// One page of rows, clamped so a page that emptied out (say, after matching its last rows) shows the last one left.
export default function pageOf(rows, page) {
	const pageCount = Math.max(1, Math.ceil(rows.length / pageSize));
	const current = Math.min(page, pageCount - 1);
	return {
		rows: rows.slice(current * pageSize, (current + 1) * pageSize),
		page: current,
		pageCount,
		size: pageSize,
		total: rows.length,
	};
}
